<ngb-accordion activeIds="ballast-managment">
    <ngb-panel id="ballast-managment">
        <ng-template ngbPanelHeader let-panel>
            <app-accordion-header [panel]="panel">
                <h5 translate>Ballast water managment</h5>
            </app-accordion-header>
        </ng-template>
        <ng-template ngbPanelContent>
            <div class="row mt-2">
                <div class="col-4">
                    <app-control label='The principal ballast water managment method(s) employed on this ship is/are'
                        type="codelist" codelist="BallastWaterMethod"
                        [(ngModel)]="model.ballastWaterManagmentMethodId" [entity]="model" property="ballastWaterManagmentMethodId"></app-control>
                </div>
                <div class="col-4" *ngIf="model.ballastWaterManagmentMethodId === 'ID2'">
                    <app-control label='In accordance with regulation D2 (description)' [maxlength]="250"
                        [(ngModel)]="model.ballastWaterD2Description" [entity]="model" property="ballastWaterD2Description"></app-control>
                </div>
                <div class="col-4" *ngIf="model.ballastWaterManagmentMethodId === 'OAR'">
                    <app-control label='Other approach in accordance with regulation (description)' [maxlength]="250"
                        [(ngModel)]="model.ballastWaterOtherDescription" [entity]="model" property="ballastWaterOtherDescription"></app-control>
                </div>
                <div class="col-4">
                    <app-control label='Total number of tanks/holds to be discharged'
                        type="number" format="#"
                        [(ngModel)]="model.totalNumberOfBallastTanksDischarged" [entity]="model" property="totalNumberOfBallastTanksDischarged"></app-control>
                </div>
            </div>
            <ngb-accordion activeIds="ballast-info">
                <ngb-panel id="ballast-info">
                    <ng-template ngbPanelHeader let-panel>
                        <app-accordion-header [panel]="panel">
                            <h5 translate>Ballast Water Tanks Discharge List</h5>
                        </app-accordion-header>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <app-entity-form [options]="regulationsFormOptions" [grid]="ballastRegulationsGrid"></app-entity-form>
                        <app-grid #ballastRegulationsGrid [data]="model.ballastRegulations">
                            <kendo-grid-column field="managedInAccordanceWithId"
                                title="{{'Of tanks/holds to be discharged, how many were managed in accordance with?' | translate}}">
                                <ng-template kendoGridCellTemplate let-row>
                                    {{row.managedInAccordanceWithId | codelist:'BallastWatersDischargeMethod' | async}}
                                </ng-template>
                            </kendo-grid-column>
                            <kendo-grid-column field="numberOfTanksDischarged" title="{{'No. of tanks/hold to be discharged' | translate}}"></kendo-grid-column>
                            <kendo-grid-column field="otherMethodReason" title="{{'Other method (description and reason)' | translate}}"></kendo-grid-column>
                            <kendo-grid-column field="notManagedReason" title="{{'If any tanks/holds not managed state reason why not' | translate}}"></kendo-grid-column>
                        </app-grid>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
            <div class="row mt-2">
                <div class="col-3">
                    <app-control label='BWMS used, if any?' [maxlength]="250"
                        [(ngModel)]="model.bwmsUsed" [entity]="model" property="bwmsUsed"></app-control>
                </div>
                <div class="col-3">
                    <app-control label='Manufacturer' [maxlength]="50"
                        [(ngModel)]="model.manufacturer" [entity]="model" property="manufacturer"></app-control>
                </div>
                <div class="col-3">
                    <app-control label='Model' [maxlength]="50"
                        [(ngModel)]="model.model" [entity]="model" property="model"></app-control>
                </div>
                <div class="col-3">
                    <app-control label='Fully Operational' type="yesno"
                        [(ngModel)]="model.fullyOperational" [entity]="model" property="fullyOperational"></app-control>
                </div>
                <div class="col-3">
                    <app-control label='Last bypass date' type="datetime"
                        [(ngModel)]="model.lastByPassDate" [entity]="model" property="lastByPassDate"></app-control>
                </div>
            </div>
        </ng-template>
    </ngb-panel>
</ngb-accordion>
<div class="mb-3"></div>
<ngb-accordion activeIds="ballast-info">
    <ngb-panel id="ballast-info">
        <ng-template ngbPanelHeader let-panel>
            <app-accordion-header [panel]="panel">
                <h5 translate>Ballast Water tanks</h5>
            </app-accordion-header>
        </ng-template>
        <ng-template ngbPanelContent>
            <div class="row mt-2">
                <div class="col">
                    <app-control label='Ballast Water management plan on board?'
                        [(ngModel)]="model.ballastWaterPlanOnBoard" [entity]="model" property="ballastWaterPlanOnBoard" type="yesno"></app-control>
                </div>
                <div class="col">
                    <app-control label='Has this been implemented?'
                        [(ngModel)]="model.hasBeenImplemented" [entity]="model" property="hasBeenImplemented" type="yesno"></app-control>
                </div>
                <div class="col">
                    <app-control label='Total number of tanks on board?'
                        [(ngModel)]="model.ballastTanksOnBoard" [entity]="model" property="ballastTanksOnBoard" type="number"></app-control>
                </div>
                <div class="col">
                    <app-control label='Number of tanks in ballast' [(ngModel)]="model.tanksInBallast" [entity]="model" property="tanksInBallast"
                        type="number"></app-control>
                </div>
                <div class="col-3">
                    <app-control label='Number of tanks exchanged' [(ngModel)]="model.tanksExchanged" [entity]="model" property="tanksExchanged"
                        type="number">
                    </app-control>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-4">
                    <app-control label='Number of tanks not exchanged'
                        [(ngModel)]="model.tanksNotExchanged" [entity]="model" property="tanksNotExchanged" type="number"></app-control>
                </div>
            </div>
            <hr>
            <h4 translate>BALLAST WATER HISTORY LIST</h4>
            <app-entity-form [options]="watersFormOptions" [grid]="ballastWatersGrid"></app-entity-form>
            <app-grid #ballastWatersGrid [data]="model.ballastWaters">
                <kendo-grid-column [width]="100" field="ballastTankTypeId"
                    title="{{'Ballast Water Tank Type' | translate}}">
                    <ng-template kendoGridCellTemplate let-row>
                        {{row.ballastTankTypeId | codelist:'BallastTankType' | async}}
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column-group title="{{'Ballast Water Source' | translate}}" headerClass="text-center">
                    <kendo-grid-column [width]="100" field="sourceDate" format="d"
                        title="{{'Source Date (dd/mm/yyyy)' | translate}}"></kendo-grid-column>
                    <kendo-grid-column [width]="100" field="sourcePortId" title="{{'Port' | translate}}">
                        <ng-template kendoGridCellTemplate let-row>
                            {{row.sourcePortId | codelist:'Location' | async}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column [width]="100" field="sourceLatitude" title="{{'Latitude' | translate}}">
                    </kendo-grid-column>
                    <kendo-grid-column [width]="100" field="sourceLongitude" title="{{'Longitude' | translate}}">
                    </kendo-grid-column>
                    <kendo-grid-column [width]="100" field="sourceVolume" title="{{'Volume' | translate}}">
                    </kendo-grid-column>
                    <kendo-grid-column [width]="100" field="unitOfMeasureSourceId"
                        title="{{'Unit of Measurment (Source)' | translate}}">
                        <ng-template kendoGridCellTemplate let-row>
                            {{row.unitOfMeasureSourceId | codelist:'BallastWaterUnitOfMeasure' | async}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column [width]="100" field="sourceTemperature" title="{{'Temp.' | translate}}">
                    </kendo-grid-column>
                </kendo-grid-column-group>

                <kendo-grid-column-group title="{{'Ballast Water Exchange' | translate}}" headerClass="text-center">
                    <kendo-grid-column [width]="100" field="ballastWaterExchangeId"
                        title="{{'Ballast Water Exchange' | translate}}">
                        <ng-template kendoGridCellTemplate let-row>
                            {{row.ballastWaterExchangeId | codelist:'BallastWaterExchange' | async}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column [width]="100" field="exchangeDate" format="d"
                        title="{{'Exchange Date (dd/mm/yyyy)' | translate}}"></kendo-grid-column>
                    <kendo-grid-column [width]="100" field="endpointLatitudeLongitude"
                        title="{{'Endpoint Lat./Long.' | translate}}"></kendo-grid-column>
                    <kendo-grid-column [width]="100" field="exchangeVolume" title="{{'Volume' | translate}}">
                    </kendo-grid-column>
                    <kendo-grid-column [width]="100" field="unitOfMeasureExchangeId"
                        title="{{'Unit of Measurment' | translate}}">
                        <ng-template kendoGridCellTemplate let-row>
                            {{row.unitOfMeasureExchangeId | codelist:'BallastWaterUnitOfMeasure' | async}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column [width]="100" field="exchange" title="{{'Exch. %' | translate}}">
                    </kendo-grid-column>
                    <kendo-grid-column [width]="100" field="seaHeight" title="{{'SEA Hgt.' | translate}}">
                    </kendo-grid-column>
                </kendo-grid-column-group>

                <kendo-grid-column-group title="{{'Ballast Water Discharge' | translate}}" headerClass="text-center">
                    <kendo-grid-column [width]="100" field="dischargeDate" format="d"
                        title="{{'Discharge Date (dd/mm/yyyy)' | translate}}"></kendo-grid-column>
                    <kendo-grid-column [width]="100" field="dischargePortId"
                        title="{{'Port of Discharge' | translate}}">
                        <ng-template kendoGridCellTemplate let-row>
                            {{row.dischargePortId | codelist:'Location' | async}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column [width]="100" field="dischargeLatitude" title="{{'Latitude' | translate}}">
                    </kendo-grid-column>
                    <kendo-grid-column [width]="100" field="dischargeLongitude" title="{{'Longitude' | translate}}">
                    </kendo-grid-column>
                    <kendo-grid-column [width]="100" field="dischargeVolume" title="{{'Volume' | translate}}">
                    </kendo-grid-column>
                    <kendo-grid-column [width]="100" field="unitOfMeasureDischargeId"
                        title="{{'Unit of Measurment' | translate}}">
                        <ng-template kendoGridCellTemplate let-row>
                            {{row.unitOfMeasureDischargeId | codelist:'BallastWaterUnitOfMeasure' | async}}
                        </ng-template>
                    </kendo-grid-column>
                    <kendo-grid-column [width]="100" field="dischargeSalinity" title="{{'Salinity' | translate}}">
                    </kendo-grid-column>
                </kendo-grid-column-group>
            </app-grid>
        </ng-template>
    </ngb-panel>
</ngb-accordion>
<div class="mb-3"></div>
<ngb-accordion activeIds="ballast-exchanges">
    <ngb-panel id="ballast-exchanges">
        <ng-template ngbPanelHeader let-panel>
            <app-accordion-header [panel]="panel">
                <h5 translate>Ballast Water conducted exchanges</h5>
            </app-accordion-header>
        </ng-template>
        <ng-template ngbPanelContent>
            <div class="row mt-2">
                <div class="col">
                    <app-control
                        label='If exchanges were not conducted, state other control action(s) taken'
                        [(ngModel)]="model.otherControlActions" [entity]="model" property="otherControlActions" type="textarea"></app-control>
                </div>
                <div class="col">
                    <app-control label='If none, state reason why not'
                        [(ngModel)]="model.controlActionsReasonIfNo" [entity]="model" property="controlActionsReasonIfNo" type="textarea"></app-control>
                </div>
            </div>
        </ng-template>
    </ngb-panel>
</ngb-accordion>
<div class="mb-3"></div>
<ngb-accordion activeIds="ballast-imo">
    <ngb-panel id="ballast-imo">
        <ng-template ngbPanelHeader let-panel>
            <app-accordion-header [panel]="panel">
                <h5 translate>IMO Guidelines</h5>
            </app-accordion-header>
        </ng-template>
        <ng-template ngbPanelContent>
            <div class="row mt-2">
                <div class="col-3">
                    <app-control label='IMO Guidelines on board?'
                        [(ngModel)]="model.imoGuidelinesOnBoard" [entity]="model" property="imoGuidelinesOnBoard" type="yesno"></app-control>
                </div>
            </div>
        </ng-template>
    </ngb-panel>
</ngb-accordion>
